const init = (options) => {
  const {
    activator,
    menuToggle,
    searchMenu,
  } = options;
  const searchBtn = document.querySelector(activator);
  const searchDiv = document.querySelector(searchMenu);
  const searchInput = searchDiv.querySelector('.search-input');

  const closeSearchMenuOnBodyClick = (event) => {
    if (event.target.closest('.search-item') === null) {
      searchDiv.classList.remove(menuToggle);
      searchBtn.setAttribute('aria-expanded', 'false');
      searchInput.blur();
      document.querySelector('body').removeEventListener('click', closeSearchMenuOnBodyClick);
    }
  };

  searchBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    if (window.innerWidth < 992) {
      searchDiv.classList.toggle(menuToggle);
      if (searchDiv.classList.contains(menuToggle)) {
        searchBtn.setAttribute('aria-expanded', 'true');
        document.querySelector('body').addEventListener('click', closeSearchMenuOnBodyClick);
        searchInput.focus();
      } else {
        searchBtn.setAttribute('aria-expanded', 'false');
        searchInput.blur();
        document.querySelector('body').removeEventListener('click', closeSearchMenuOnBodyClick);
      }
    }
  });
};

export default {
  init,
};
